import getCurrentInitialValue from "../get-current-initial-value";
import computeFnValues from "../percents/compute-fn-values";
import getJoinedFnArray from "../percents/get-joined-fn-array";
import computeSimpleValues from "./compute-simple-values";

/**
 * Compute the function in the "current" resolution
 * @param {ValueLevelMapProps} map
 * @param {Map<String, Map<String, PureValueMapProps>>} actives activeProperties
 * @param {Boolean} isInitial
 * @param {Boolean} isSafariInitial
 * @returns {String}
 */
const getCurrentSpaceValue = (map, actives, isInitial, isSafariInitial) => {
  const result = [];

  /** Space-separated values */
  const initials = /** @type {Array<any>} */ (map.get("values"));

  /** Space divider (" ") */
  const divider = /** @type {String} */ (map.get("divider"));

  for (const original of initials) {
    const numbers = /** @type {Array<String | Array<String>>} */ ([]);
    const strings = /** @type {Array<String | Array<String>>} */ ([]);
    const initial = /** @type {PropertyValueProps} */ (original);
    const isFn = /** @type {Boolean} */ (initial.get("v_is-fn"));
    const isCalc = /** @type {Boolean} */ (initial.get("v_is-calc"));

    let output = /** @type {String} */ (initial.get("v_output"));

    if (isInitial) {
      result.push(getCurrentInitialValue(initial, output, isFn, isCalc));
      continue;
    }

    /** Initial value */
    const path = /** @type {String} */ (initial.get("path"));

    /** Find the exact value in the "activeProperties" according the initial value path */
    const active = /** @type {Map<String, PropertyValueProps>} */ (
      actives.get(path)
    );

    if (!active) {
      continue;
    }

    /**
     * Active item
     * @type {PropertyValueProps}
     */
    let item;

    /** Loop trough currently active values */
    for (item of active.values()) {
      const progress = /** @type {Number} */ (item.get("progress"));

      /** Initial is a function */
      if (isFn && !isCalc) {
        numbers.push(computeFnValues(progress, item, initial, numbers));
      } else {
        computeSimpleValues(
          item,
          initial,
          progress,
          output,
          numbers,
          strings,
          isSafariInitial
        );
      }
    }

    if (isFn && !isCalc) {
      result.push(getJoinedFnArray(initial, numbers));
    } else if (strings.length) {
      result.push(strings.join(""));
    } else {
      result.push(`calc(${output} - ${numbers.join(" - ")})`);
    }
  }

  return result.join(divider);
};

export default getCurrentSpaceValue;
